<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Dacr Membership</template>

    <Sheet.Body
      class="px-[30px]! pt-5 pb-[calc(env(safe-area-inset-bottom)+20px)]!"
    >
      <DacrMembershipBody />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import DacrMembershipBody from './DacrMembershipBody.vue'

const { close } = useSheet()
</script>
